module.exports = __webpack_public_path__ + "img/bus-partner-img7.7284a11d.png";